export default {
  // 获取用户时区+8  +8.5 +10.75 -5
  timeZone () {
    let timezone = new Date().getTimezoneOffset() / 60
    // let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + String(-timezone) : -timezone
    return zone
  },
  globetime () {
    let timezone = new Date().getTimezoneOffset() / 60
    let mins = (new Date().getTimezoneOffset() / 60 - parseInt(timezone)) * 60
    let zone = -timezone > 0 ? '+' + -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00') : -parseInt(timezone) + ':' + (-mins > 0 ? -mins : '00')
    return zone
  },
  getTimeZoneCity () {
    let timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone; //'Asia/Shanghai'
    return timeZoneId
  },
  formatDate (time) {
    var date = new Date(time.replace(/-/g, '/'))
    return date
  },
  /**
   * 金额千位分隔
   * @param {num} num 2999
   * @returns 2,999.00
   */
  numFormat (num) {
    let price = Number(num)
      .toFixed(2)
      .toString()
      .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
      // var c = (num.toString().indexOf ('.') !== -1) ? num.toLocaleString() : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return price
  },
  /**
   * 日期转换格式
   * @param {date} date 2021-06-02 21:28:47
   * @returns 2021/6/2
   */
  setDate (date) {
    var date = new Date(date)
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
  },
  /**
   * 日期转换星期
   * @param {date} date 2021-06-02 21:28:47
   * @returns Sunday
   */
  setDateToWeek (date) {
    var date = new Date(date), week
    if (date.getDay() == 0) week = 'Sunday'
    if (date.getDay() == 1) week = 'Monday'
    if (date.getDay() == 2) week = 'Tuesday'
    if (date.getDay() == 3) week = 'Wednesday'
    if (date.getDay() == 4) week = 'Friday'
    if (date.getDay() == 5) week = 'Friday'
    if (date.getDay() == 6) week = 'Saturday'
    return week
  },
  /**
 * 数字转换英文
 * @param {date} date 2021-06-02 21:28:47
 * @returns Sunday
 */
  setWeek (num) {
    switch (num) {
      case '7':
        return 'Sunday'
        break
      case '6':
        return 'Saturday'
        break
      case '5':
        return 'Friday'
        break
      case '4':
        return 'Thursday'
        break
      case '3':
        return 'Wednesday'
        break
      case '2':
        return 'Tuesday'
        break
      case '1':
        return 'Monday'
        break
      default:
        return ''
    }
  },
  toAppStore () {
    window.location.href = 'https://apps.apple.com/cn/app/id1573232431'
  },
  toGooglePlay () {
    window.location.href = 'http://www.pgyer.com/jtIz'
  },
  setCookies (obj, limitTime) {
    // let data = new Date(new Date().getTime() + limitTime * 24 * 60 * 60 * 1000).toUTCString()

    for (let i in obj) {
      document.cookie = i + '=' + obj[i]
    }
  },
  getCookie (name) {
    // let re = new RegExp('s?' + cookieName + '=([^;]+)(;|$)')
    var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'))
    if (arr != null) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  clearCookie (name) {
    let json = {}
    json[name] = ''
    this.setCookies(json, -1)
  },
  GetQueryString (name) {
    // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    if (window.location.href.indexOf(name) > 0) { var r = window.location.href.split(name)[1].split('=')[1] }
    if (r != null) return r; return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js